import { Injectable } from '@angular/core';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { PregledIzdatniceTrosakService } from '../pages/pregled-izdatnice-trosak/pregled-izdatnice-trosak.service';
import { AuthService } from '../shared/services';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root',
})
export class PdfZaReversService {

  idkorisnik: any = localStorage.getItem('idsecuser');
  access_token: any = sessionStorage.getItem('token');
  idfirma: any = localStorage.getItem('firma');
  stavke: any = [];

  constructor(private service: PregledIzdatniceTrosakService, private authService: AuthService) {}

  reversPDF(e) {
    //console.log(e);
    //console.log(e.data);

    this.stavke = [];
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      pz_id: e.data.pz_id,
    };
    //console.log(podaciZaSlanje);

    /* kod zavrsenih ili storniranih dohvaca iz jedne tablice a kod onih u izradi iz druge zato su razliciti api-i */
    if (e.data.pz_status == 'Z' || e.data.pz_status == 'S') {
      this.service.dohvatiJednuIzdatnicu(podaciZaSlanje).subscribe((res) => {
        //console.log(res);
        if (res.success === true) {
          this.stavke = res.data;
        }
        this.kreirajPDF(e.data);
      });
    }else{
      this.service.tmpprometstavkePopis(podaciZaSlanje).subscribe((res) => {
        //console.log(res);
        if (res.success === true) {
          this.stavke = res.data;
        }
        this.kreirajPDF(e.data);
      });
    }
  }

  kreirajPDF(data) {

    let broj_naloga = '';
    if (data.nl_broj) {
      broj_naloga = data.nl_broj;
    }

    let zakljucio_imeprezime = '';
    if(data.zakljucio_imeprezime){
      zakljucio_imeprezime = data.zakljucio_imeprezime;
    }

    let sifra_partnera = '';
    if(data.pa_sifra){
      sifra_partnera = data.pa_sifra;
    }

    let naziv_partnera = '';
    if(data.pa_naziv){
      naziv_partnera = data.pa_naziv;
    }

    let vrijedido = '';
    if(data.pz_vrijedido){
      vrijedido = moment(data.pz_vrijedido).format('DD.MM.YYYY.');
    }

    let napomena = '';
    if (data.pz_napomena) {
      napomena = data.pz_napomena;
    }

    let napomena2 = '';
    if (data.pz_napomena2) {
      napomena2 = data.pz_napomena2;
    }

    let hLine = {
      table: {
        widths: ['*'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };
    
    let signatureLine = {
      table: {
        widths: ['100%'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    let ct = [];

    ct.push({
      text: 'PEKAR d.o.o.',
      style: 'title',
    });

    ct.push({
      text: 'Obrtnička ulica 5 \n 32100 Vinkovci',
      style: 'subtitle',
      margin: [0, 0, 0, 15],
    });

    ct.push({
      columns: [
        {
          table: {
            widths: [200],
            body: [
              [
                {
                  table: {
                    body: [
                      [
                        {
                          text: 'Skladište:',
                          style: 'details',
                          bold: true,
                        },
                      ],
                      [
                        {
                          text: [
                            data.po_sifra +
                              ' ' +
                            data.po_naziv +
                              '\n',
                          ],
                          style: 'tableTitle',
                        },
                      ],
                    ],
                  },
                  layout: 'noBorders',
                },
              ],
            ],
          },
        },
        {
          text: [
            { text: 'Datum: ', style: 'boldRight' },
            data.datumformat + ' \n',
            { text: 'Partner: ', style: 'boldRight' },
            sifra_partnera + ' ' + naziv_partnera + ' \n',
            { text: 'Vrijedi do: ', style: 'boldRight' },
            vrijedido
          ],
          style: 'details',
          lineHeight: '1.2',
        },
      ],
    });

    ct.push({
      text: 'Revers: ' + data.pz_broj,
      style: 'mainTitle',
      alignment: 'center',
      margin: [0, 30, 0, 15],
    });

    ct.push({
      text: 'Napomena:' + ' \n' + napomena,
      margin: [0, 0, 0, 15],
    });
    
    ct.push({
      text: 'Napomena2:' + ' \n' + napomena2,
      margin: [0, 0, 0, 15],
    });

    ct.push({
      table: {
        widths: [15, 40, 40, 200, 20, 50, 35, 52],
        body: [
          [
            'RB',
            'Šifra',
            'LOT',
            'Naziv artikla',
            'Jed.',
            'Količina',
            'Cijena',
            'Vrijednost',
          ],
        ],
      },
      layout: 'lightHorizontalLines',
    });

    ct.push(hLine);
    let n = 1;
    let vrijednost = 0;
    for (let stavka of this.stavke) {
      vrijednost += Number(this.zamjenazaprazno(stavka.ukupnacijena));
      ct.push({
        table: {
          widths: [15, 40, 40, 200, 20, 50, 35, 52],
          body: [
            [
              {text: n++ +'.' },
              {text: stavka.ar_sifra },
              {text: stavka.ar_lot },
              {text: stavka.ar_naziv },
              {text: stavka.jedinicamjere_JM_SIFRA },
              {text: this.formatiraj(stavka.ps_izlaz, 2), alignment: 'right'},
              {text: this.formatiraj(stavka.ps_izlazc, 3), alignment: 'right'},
              {text: this.formatiraj(stavka.ukupnacijena, 2), alignment: 'right'},
            ],
          ],
        },
        layout: 'lightHorizontalLines',
      });
    }

    ct.push(hLine);
    ct.push({
      table: {
        widths: [510, 100],
        body: [
          [
            {
              text: 'UKUPNO',
              style: 'tableFooter',
              margin: [30, 0, 0, 0],
            },
            {
              text: this.formatiraj(vrijednost, 2) + ' €',
              style: 'tableFooter',
            },
          ],
        ],
      },
      layout: 'noBorders',
    });

    ct.push({
      absolutePosition: { x: 15, y: 700 },
      columns: [
        [{ text: 'Robu izdao: ' + zakljucio_imeprezime, margin: [0, 60, 0, 30] }, signatureLine],
        [],
        [],
        [
          {
            text: 'Robu preuzeo:',
            alignment: 'right',
            margin: [0, 60, 0, 30],
          },
          signatureLine,
        ],
      ],
    });

    var dd = {
      info: {
        title: 'Revers: ' + data.pz_id,
      },
      content: ct,
      pageMargins: 15,
      defaultStyle: {
        fontSize: 9.5,
      },
      styles: {
        title: {
          fontSize: 16,
          bold: true,
        },
        subtitle: {
          fontSize: 12,
        },
        details: {
          fontSize: 11,
        },
        boldRight: {
          bold: true,
          width: 200,
        },
        tableTitle: {
          fontSize: 12,
          bold: true,
        },
        mainTitle: {
          fontSize: 17,
          bold: true,
        },
        tableFooter: {
          bold: true,
        },
      },
    };
    pdfMake.createPdf(dd).open();
  }

  //mijenja zarez za prazan
  zamjenazaprazno(a){
    if(typeof a === 'string'){
      var iznos = a.replace(",", "");
    }else{
      iznos = a;
    }
    return iznos;
  }

  formatiraj(broj: any, dec_mj: any){
    return this.authService.formatiraj(broj, dec_mj);
  }

}
    

    
